import {
  CustomGetDailyFormInspectionsQuery,
  CustomGetDailyFormInspectionsQueryVariables,
  useCustomGetDailyFormInspectionsQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetDailyFormInspections({
  variables,
}: {
  variables: CustomGetDailyFormInspectionsQueryVariables;
}) {
  const {
    data: graphqlData,
    error,
    loading,
    fetchMore: more,
  } = useCustomGetDailyFormInspectionsQuery({
    variables,
  });

  const getData = useCallback((data: CustomGetDailyFormInspectionsQuery) => {
    return data?.getDailyFormInspections?.data || [];
  }, []);

  const getPaginatorInfo = useCallback((data: CustomGetDailyFormInspectionsQuery) => {
    return data?.getDailyFormInspections?.paginatorInfo;
  }, []);

  const data = useMemo(() => getData(graphqlData), [getData, graphqlData]);
  const paginatorInfo = useMemo(
    () => getPaginatorInfo(graphqlData),
    [getPaginatorInfo, graphqlData]
  );

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          page,
        },
      });
    },
    [more]
  );

  return { data, error, loading, fetchMore, paginatorInfo } as const;
}
